import clsx from 'clsx';
import React from 'react';

export const DragIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={clsx('fill-current', className)}
    >
      <path
        d="M9 5C9.82843 5 10.5 5.67157 10.5 6.5C10.5 7.32843 9.82843 8 9 8C8.17157 8 7.5 7.32843 7.5 6.5C7.5 5.67157 8.17157 5 9 5Z"
        fill="#202945"
      />
      <path
        d="M9 10.5C9.82843 10.5 10.5 11.1716 10.5 12C10.5 12.8284 9.82843 13.5 9 13.5C8.17157 13.5 7.5 12.8284 7.5 12C7.5 11.1716 8.17157 10.5 9 10.5Z"
        fill="#202945"
      />
      <path
        d="M10.5 17.5C10.5 16.6716 9.82843 16 9 16C8.17157 16 7.5 16.6716 7.5 17.5C7.5 18.3284 8.17157 19 9 19C9.82843 19 10.5 18.3284 10.5 17.5Z"
        fill="#202945"
      />
      <path
        d="M15 5C15.8284 5 16.5 5.67157 16.5 6.5C16.5 7.32843 15.8284 8 15 8C14.1716 8 13.5 7.32843 13.5 6.5C13.5 5.67157 14.1716 5 15 5Z"
        fill="#202945"
      />
      <path
        d="M15 10.5C15.8284 10.5 16.5 11.1716 16.5 12C16.5 12.8284 15.8284 13.5 15 13.5C14.1716 13.5 13.5 12.8284 13.5 12C13.5 11.1716 14.1716 10.5 15 10.5Z"
        fill="#202945"
      />
      <path
        d="M16.5 17.5C16.5 16.6716 15.8284 16 15 16C14.1716 16 13.5 16.6716 13.5 17.5C13.5 18.3284 14.1716 19 15 19C15.8284 19 16.5 18.3284 16.5 17.5Z"
        fill="#202945"
      />
    </svg>
  );
};
